<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col
        :span="4"
        class="cs-main-left-container"
      >
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">签到管理</span>

                <el-tabs
                  v-model="activeUniversityGroup"
                  type="card"
                >
                  <el-tab-pane name="1" v-if="!USERMANAGER.isVocationalTrainingManager">
                    <span slot="label"> 大学补习 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <signInManageList :usage='"universityTutorial"'></signInManageList>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                  <!-- <el-tab-pane name="2">
                                    <span slot="label"> 应试英语 </span>
                                    <el-row class="grid-content">
                                        <el-col>
                                          
                                        </el-col>
                                    </el-row>
                                </el-tab-pane> -->

                  <el-tab-pane name="3">
                    <span slot="label"> 职业培训 </span>
                    <el-row class="grid-content">
                      <el-col>
                        <signInManageList :usage='"vocationalTraining"'></signInManageList>
                      </el-col>
                    </el-row>
                  </el-tab-pane>

                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
/* elementui 的tabs组件出现蓝色边框问题 */

.el-tabs__item:focus.is-active.is-focus:not(:active) {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>

<script>
import navigator from "../../components/navigator";
import signInManageList from "../../components/signInManage/signInManageList";

export default {
  data() {
    return {
      loading: false,
      activeUniversityGroup: "1"
    };
  },
  components: {
    navigator,
    signInManageList
  },
  computed: {},
  created() {
    if (this.USERMANAGER.isVocationalTrainingManager 
      || (this.$route.query && this.$route.query.usage === 'vocationalTraining')){
      this.activeUniversityGroup = "3";
    }
  },
  methods: {},
  watch: {
  
  }
};
</script>



// WEBPACK FOOTER //
// src/page/admin/signInManage.vue